/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import { GetInitiativeLibrary, GetFeaturedInitiatives, GetInitiativesCategories } from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import SkeletonLoder from "../../common/skeletonLoder";
// import { NoData } from "../styles";
// import {InitiativesWrap, InitiativeCard} from '../../HealthDataManagement/styles'
// import {/*RecognitionEyeIconNew, RecognitionLaunchIcon,*/ DatePickerIconUserEvents, PeopleIconForRegisteredUsers} from '../../../utils/icons'
import DetailPopup from '../../HealthDataManagement/initiativesInfo';
import FeaturedSlider from "../../common/FeaturedSlider";
// import { CompanyCard } from "../../MainEvents/CompanyLiveEvents/styles";
import { ReservedButton } from "../../MainEvents/styles";
import LazyImage from "../../common/LazyImage/LazyImage";
import parse from 'react-html-parser';
// import moment from "moment";
import InitiativeCategoryGrid from "../../common/InitiativeCategoryGrid";
import { Heading } from "../../RecogntionAdmin/styles";
import { CompanyCard } from "../../UserDashboard/styles";
import {  RewardPointsIcon, WellnessInitiatives } from "../../../utils/icons";
import { TextContainer } from "../../ChallengeDetailsV2/WellnessChallenge/styles";

class libraryInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: this.props.companyInfo.id,
      launchDate: new Date(),
      year: new Date().getFullYear(),
      pointsArrow: false,
      loading:false,
      showDetailPopup: false,
      detailInitiative: null,
      libraryInitiatives:[],
      featuredInitiatives:[],
      initiativeCategories:[]
    };
  }

  componentDidMount() {
    this.getLibraryInitiatives(this.props.selectedYearInfo);
    this.getFeaturedInitiatives();
    this.getInitiativeCategories()
  }

  hideShowPopup = () => {
    this.setState({ showDetailPopup: false, detailInitiative:null });
  }

  showPopup = (data) => {
    this.setState({ showDetailPopup: true, detailInitiative:data })
  }

  getFeaturedInitiatives = async () => {

    try {
      const res = await fetchApi(`${GetFeaturedInitiatives}?company_id=${this.state.companyId}`, "GET");
      if (res.status === "success") {
        this.setState({ featuredInitiatives: Array.isArray(res?.data) ? res.data : [] });
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  getLibraryInitiatives = async () => {
    this.setState({ loading: true });
    let apiUrl = GetInitiativeLibrary + "/" + this.state.companyId;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        this.setState({ libraryInitiatives: res?.data,loading: false });
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  /* ─── API: Initiative Categories ────────────────────────────── */
  getInitiativeCategories = async () => {
    try {
      const res = await fetchApi(GetInitiativesCategories, "GET");
      if (res.status === "success") {
        this.setState({ initiativeCategories: Array.isArray(res?.data) ? res.data : [] });
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  chunkArray = (arr, size) => (
    arr.reduce((acc, _, i) => 
      i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc
    , [])
  );


 

  renderFeaturedInitiativeCard = (data) => {
    const { history } = this.props;
    const onCardClick = () => history.push({
      pathname: "/company/company-initiative",
      state: { id: data?.id, initiative_name: data?.initiative_name || data?.title, initiativeDetails: data,  fromLibrary: true }
    });


    const handleViewDetails = () => {
      const { history } = this.props;
      history.push({pathname:`/company/initiative-details/${data?.company_initiative_id}` , state:{initiativeDetails:data, fromLibrary: true}});
      // const { detailInitiative } = this.state;
      // this.setState({ showDetailPopup: true, detailInitiative: detailInitiative });
    }

    return (
      <div className="card" style={{ paddingRight: '0', marginRight: '-30px !important' }}>
        <CompanyCard
          // className="featChallanges"
          // detailsCardPadding="0 0 10px 20px"
          // width="1248px"
          onClick={onCardClick}
          detailsCardPadding="20px" 
          isCursorPointer={"default"}
        >
          <LazyImage className="imageCardUserDashboard"
            src={`${ImageUrl}/${data?.thumbnail || data?.initiative_white_icon}`}
            alt="initiative"
          />
          <div className="detailsCard">
            <div className="title" style={{marginBottom:'14px'}}>{data?.title || data?.initiative_name}</div>
            {data?.description  ? <TextContainer isFontSize={"16px"} isLineHeight={"20px"} isFontWeight={"400"}>
              {parse(data?.description || "")}
            </TextContainer>:null}
            <div className="date">
              <div className="iconV1"><RewardPointsIcon /></div>
              <div className="detail">  +{data?.points} health and wellness points</div>
            </div>
            <div className="moving-btn" style={{ marginTop: "auto", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "16px" }}>
              <ReservedButton active={true} width="268px" height="40px"
                onClick={(e) => {
                  e.stopPropagation();
              
                  if (data?.re_launch_status) {
                    onCardClick();
                  } else {
                    handleViewDetails();
                  }
                }}
              //  onClick={ data?.re_launch_status ? onCardClick : handleViewDetails}
              >
                <div style={{ marginRight: "8px" }}>{data?.re_launch_status ? "Launch Initiative" :  "View Initiative" }</div>
              </ReservedButton>
            </div>
          </div>
        </CompanyCard>
      </div>
    );
  };

  redirectToCompanyInitiative = (obj) => {
    const { history } = this.props;
    history.push({pathname: "/company/company-initiative", state: {id: obj?.id, initiative_name: obj?.initiative_name,initiativeDetails:obj,   fromLibrary: true  }});
  };

  // libraryInitiatives = () =>{
  //   const { libraryInitiatives } = this.state;
  //   const initiativeChunks = this.chunkArray(libraryInitiatives, 3);
  //   return(
  //     <InitiativesWrap>
  //       <div className="details">
  //         {initiativeChunks.map((chunk, chunkIndex) => (
  //           <React.Fragment key={chunkIndex}>
  //             <div className="initiative-row">
  //               {chunk.map((initiative) => (
  //                 <div className="initiative-card" key={initiative.id}>
  //                   <InitiativeCard background={initiative?.color}>
  //                     <div className="icon">
  //                       <img src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt="initiative" />
  //                     </div>
  //                     <div className="initiative-title">{initiative.initiative_name}</div>
  //                     <div className="end-container"  onClick={!initiative?.re_launch_status?() => this.setState({showDetailPopup:true,detailInitiative:initiative}):() => this.redirectToCompanyInitiative(initiative)}>
  //                       {initiative?.re_launch_status?RecognitionLaunchIcon(): RecognitionEyeIconNew()}
  //                     </div>
  //                   </InitiativeCard>
  //                 </div>
  //               ))}
  //             </div>
  //             {/* Border after every row of 3 cards */}
  //             {chunkIndex+1!==initiativeChunks?.length&&<div className="border-card"/>}
  //           </React.Fragment>
  //         ))}
  //       </div>
  //     </InitiativesWrap>
  //   )
  // }

  render() {
    const { /*libraryInitiatives,*/ loading, showDetailPopup, detailInitiative, featuredInitiatives,initiativeCategories } = this.state;

    if (loading) {
      return <div style={{width:'385px'}}>
        <SkeletonLoder width={"1248px"} height={"500px"}/>
      </div>;
    }

    return (<>
      <FeaturedSlider
        items={featuredInitiatives}
        title={"Featured Initiatives"}
        renderItem={this.renderFeaturedInitiativeCard}
        titleIcon={WellnessInitiatives('#184A61')}
      />
      
      {/* Initiative Categories Grid */}
      <Heading>
        {/* <div className='icon' style={{marginRight:'4px'}}>
          {AdminCategoriesNew("#184A61")}
        </div> */}
        Health Initiatives categories
      </Heading>
      <InitiativeCategoryGrid
        categories={initiativeCategories}
        onCategoryClick={(category) =>
          this.props.history.push({
            pathname: `/company/initiatives/library/${category.id}`,
            state: { category: category?.category_name || category?.name },
          })
        }
      />
      {/* {libraryInitiatives?.length > 0 ? this.libraryInitiatives():<NoData>No Data Found!</NoData>} */}
      {showDetailPopup && <DetailPopup showModal={showDetailPopup} detailInitiative={detailInitiative} onClose={this.hideShowPopup} companyId={this.props.companyInfo.id}/>}
    </>
    );
  }
}

libraryInitiative.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.any,
  companyInfo: PropTypes.any,
  selectedYearInfo:PropTypes.number,
};

export default connect(
  null,
  null
)(libraryInitiative);
